export default "__VITE_ASSET__DyeP8MRY__"